import dynamic from 'next/dynamic'

const ActiveLink = dynamic(() => import('../../common/active-link'))
const Container = dynamic(() => import('../../common/container'))
const Logo = dynamic(() => import('../../common/logo'))

const DesktopHeader = ({
  userData,
  checkWalletDataForLink,
  renderSignInOut,
  styles,
  pathname,
  Link,
}) => {
  return (
    <header
      className={
        pathname.includes('app/') || pathname.includes('dashboard/')
          ? styles.headerWhite
          : styles.header
      }
    >
      <Container classNames="flex justify-between items-center">
        <Link href={userData ? '/?loggedin=true' : '/'}>
          <a>
            <Logo />
          </a>
        </Link>
        <nav className={styles.nav}>
          {/* Shutdown mode: Navigation disabled - only key retrieval available */}
          {userData && (
            <ActiveLink
              href="/app/shutdown"
              activeClassName={styles.active}
              activatedonLinks="app/"
            >
              <a
                className={
                  !(
                    pathname.includes('app/') || pathname.includes('dashboard/')
                  )
                    ? styles.navItem
                    : styles.navItemWhite
                }
              >
                Retrieve Keys
              </a>
            </ActiveLink>
          )}
        </nav>
        {renderSignInOut(false)}
      </Container>
    </header>
  )
}
export default DesktopHeader
